import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import * as AssetUtils from '../../../../utils/asset';
import * as ItemUtils from '../../utils';

import * as videoPlayers from '../../../videoPlayers.jsx';

import { ItemVideoDetail } from '../item-components';
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
/**
 * Outputs an item's detail/full asset (eg full image or video embed)
 *
 * @namespace
 * @memberOf Common.Components.DisplayItems.Elements
 *
 * @prop item : {object} display item
 */
class ItemDetailAsset extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const item = this.props.item;

    let _theAsset = false;

    if (item.assets) {
      // Video assets.
      if (item.meta.contentType && AssetUtils.isVideoOrGif(item.meta.contentType)) {
        const shouldAutoPlay = true;
        const isMuted = false;

        _theAsset = ItemUtils.getVideoComponent({ item, itemOpts: this.props.itemOpts, shouldAutoPlay, isMuted });
        // Image assets.
      } else {
        const _imgSrc = AssetUtils.assetFromRef(
          item.assets.main || item.featureImageAssetRef,
          this.props.assetUrl,
          this.props.assetUgcUrl
        );

        _theAsset = (
          <div className="xMediaContainer xRenderEmbed xAssetImage">
            <img
              src={_imgSrc.src}
              alt={
                _.get(item, 'content.content') ||
                _.get(item, 'content.caption') ||
                _.get(item, 'content.heading') ||
                'Content Image'
              }
            />
          </div>
        );
      }
    }

    return _theAsset;
  }

  //  new render method once ItemDetailVideo is flushed out (resolve global NGX legacy scope).
  renderv2() {
    const { contentType, assetUrl } = this.props;
    const wrapperClasses = classnames({
      xMediaContainer: true,
      xRenderEmbed:    true,
      xAssetVideo:     contentType === 'video',
      xAssetImage:     contentType !== 'video',
    });
    // TODO: if/when used - this needs to account for 'gif' contentType as well
    return (
      <div className={wrapperClasses}>
        <Choose>
          <When condition={contentType === 'video'}>
            <ItemDetailVideo asset={assetUrl} />
          </When>
          <When condition={contentType !== 'video'}>
            <img src={assetUrl} alt="" />
          </When>
        </Choose>
      </div>
    );
  }
}

ItemDetailAsset.propTypes = {
  item:     PropTypes.object.isRequired,
  assetUrl: PropTypes.string,
};

export default ItemDetailAsset;
